import { adminApi as generatedAdminApi } from '@/store/codegen/generated/adminApi'

const transformUser = (user) => {
  if (user.userMetadata) {
    user.userMetadata = JSON.stringify(user.userMetadata, null, 2)
  }
  if (user.appMetadata) {
    user.appMetadata = JSON.stringify(user.appMetadata, null, 2)
  }
  return user
}

export const userApi = generatedAdminApi.enhanceEndpoints({
  addTagTypes: ['user'],
  endpoints: {
    listUsers: {
      // HACK: temporary override listUser query, should remove this and use the one
      // from auto generated endpoint after the openapi doc is well written
      query: (queryArg) => ({
        url: '/v1/users',
        params: {
          page: queryArg.page,
          pageSize: queryArg.pageSize,
          sort: queryArg.sort,
          email: queryArg.email,
          phoneNumber: queryArg.phoneNumber,
          name: queryArg.name,
          preferredUsername: queryArg.preferredUsername
        }
      }),
      transformResponse: (response) => {
        response.users = response.users.map(transformUser)
        return response
      },
      providesTags: (result, error) => {
        return (
          result
            ? [
                ...result.users.map(({ id }) => ({ type: 'user', id })),
                // PARTIAL-LIST denotes that the list is partial, which is paginated
                { type: 'user', id: 'PARTIAL-LIST' }
              ]
            : [{ type: 'user', id: 'PARTIAL-LIST' }]
        )
      }
    },
    getUser: {
      providesTags: (result, error, { id }) => [{ type: 'user', id }],
      transformResponse: transformUser
    },
    createUser: {
      invalidatesTags: ['user']
    },
    updateUser: {
      invalidatesTags: (result, error, { id }) => [{ type: 'user', id }]
    },
    deleteUser: {
      invalidatesTags: ['user']
    }
  }
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useListUsersQuery,
  useGetUserQuery,
  useCreateUserMutation,
  useUpdateUserMutation,
  useDeleteUserMutation
} = userApi
